<template>
    <div class="mt-3">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="col-md-8">
                <h4>↩️ Revert Invoices</h4>
            </div>
        </div>

        <!-- Form Section -->
        <div class="card shadow-sm border-0">
            <div class="card-body">
                <div class="row g-3 align-items-end">
                    <!-- Select Option -->
                    <div class="col-md-4">
                        <label for="invoiceType" class="form-label fw-bold">Invoice Type</label>
                        <select id="invoiceType" v-model="form.trantype" class="form-control form-cascade-control input-small">
                            <option value="0" disabled>Select invoice type</option>
                            <option :value="1">Purchase </option>
                            <option :value="2">Sale </option>
                        </select>
                    </div>

                    <!-- Input Box -->
                    <div class="col-md-4">
                        <label for="invoiceId" class="form-label fw-bold">Invoice ID/Number</label>
                        <input type="text" id="invoiceId" class="form-control form-cascade-control input-small"
                            v-model="form.transactionid" placeholder="Enter Invoice ID or Number" />
                    </div>

                    <!-- Submit Button -->
                    <div class="col-md-2">
                        <button class="btn btn-primary" @click="submitForm" :disabled="!form.trantype || !form.transactionid">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            form: {
                trantype: "",
                transactionid: "",
            },
        };
    },
    methods: {
        async submitForm() {
            if (!this.form.trantype || !this.form.transactionid) {
                alert("Please select an invoice type and enter an invoice ID.");
                return;
            }

            if (!confirm(`Are you sure you want to revert this ${this.form.trantype === 1 ? 'purchase' : 'sale'} invoice with ID: ${this.form.transactionid}`)) {
                return;
            }

            try {
                // Example of a POST request. You'll need to adjust the URL and payload.
                const response = await axios.post('/api/vsdg/setting/revert-invoices', this.form);
                alert(response.data.message);
                // Reset form after submission
                this.form.trantype = "";
                this.form.transactionid = "";
            } catch (error) {
                console.error("Error reverting invoice:", error);
                alert("Failed to revert invoice. Please check the console for details.");
            }
        },
    },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
}
</style>